module.exports = __webpack_public_path__ + "img/chofu_news_on.d9c0d2e2.svg";